import ListingVisibility from './view';

const ListingVisibilityPage = {
    name: 'ListingVisibility',
    list: ListingVisibility,
};

export default ListingVisibilityPage;